module.exports = "/assets/_next/static/images/incomplete-portrait-4638f8b3c5822499cb95e2c4def5d83a.png";